
import React, { useEffect, useState } from "react";
import "./Styles.css";

const DEFAULT_PHRASES = [
  "Your brand. Your casino.",
  "Original games. Built in.",
  "One back office. Full control."
];

const EthosinoTypewriter = ({
  phrases = DEFAULT_PHRASES,
  typingSpeed = 65,
  eraseSpeed = 35,
  holdDelay = 2200,
  betweenDelay = 350,
  className = ""
}) => {
  const [displayed, setDisplayed] = useState("");
  const [reducedMotion, setReducedMotion] = useState(false);

  // Stable dependency even if the parent passes an inline array.
  const phraseKey = phrases.join("\u0000");
  const words = phraseKey.split("\u0000").filter(Boolean);

  const longestPhrase = words.reduce(
    (longest, phrase) =>
      phrase.length > longest.length ? phrase : longest,
    ""
  );

  // Respect user accessibility preferences.
  useEffect(() => {
    const media = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );

    const update = () => setReducedMotion(media.matches);

    update();

    media.addEventListener?.("change", update);

    return () => {
      media.removeEventListener?.("change", update);
    };
  }, []);

  useEffect(() => {
    if (!words.length) return;

    if (reducedMotion) {
      setDisplayed(words[0]);
      return;
    }

    let wordIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer;

    setDisplayed("");

    const tick = () => {
      const currentWord = words[wordIndex];

      if (!deleting) {
        // Type one character.
        if (charIndex < currentWord.length) {
          charIndex++;

          setDisplayed(currentWord.slice(0, charIndex));

          timer = setTimeout(tick, typingSpeed);
        } else {
          // Finished typing: hold the complete sentence.
          deleting = true;

          timer = setTimeout(tick, holdDelay);
        }
      } else {
        // Erase one character.
        if (charIndex > 0) {
          charIndex--;

          setDisplayed(currentWord.slice(0, charIndex));

          timer = setTimeout(tick, eraseSpeed);
        } else {
          // Continue to the next sentence.
          wordIndex = (wordIndex + 1) % words.length;
          deleting = false;

          timer = setTimeout(tick, betweenDelay);
        }
      }
    };

    timer = setTimeout(tick, betweenDelay);

    return () => {
      clearTimeout(timer);
    };
  }, [
    phraseKey,
    reducedMotion,
    typingSpeed,
    eraseSpeed,
    holdDelay,
    betweenDelay
  ]);

  return (
    <span
      className={`eth-typewriter ${className}`}
      aria-label={words.join(". ")}
    >
      {/* Invisible text reserves space to prevent layout shifts */}
      <span
        className="eth-typewriter__measure"
        aria-hidden="true"
      >
        {longestPhrase}{"\u00a0"}
      </span>

      {/* Actual animated text */}
      <span className="eth-typewriter__live" aria-hidden="true">
        <span className="eth-typewriter__text">
          {displayed}
        </span>

        {!reducedMotion && (
          <span className="eth-typewriter__cursor" />
        )}
      </span>
    </span>
  );
};

export default EthosinoTypewriter;
